'use strict';

MxCurrencyController.$inject = ['$element', '$q', '$timeout', 'mx.internationalization', '$scope'];

// TODO: In future globalization.defaultCurrencyCode should be defined in ServiceStore.
// TODO: New mx-object-currency should be created in SolutionBuilderAgent were it will be used to fill defaultCurrencyCode in this object.
function MxCurrencyController($element, $q, $timeout, i18n, $scope) {
	var vm = this;

	vm.$onInit = function () {
		$scope.$applyAsync(() => {
			vm.inputContainer = $element.find('md-input-container.mx-currency');
			vm.valueInput = $element.find('input.mx-currency--value');
			vm.codeSelect = $element.find('select.mx-currency--cc');

			if (vm.focusOnInit) {
				vm.valueInput.focus();
			}
		});

		mx.components.FormControlControllerBase.call(vm, $timeout);

		vm.display = vm.display || 'default';
		if (vm.display === 'default') {
			vm.display = vm.config && (vm.config.showCurrencyCode === true || vm.config.showCurrencyCode === 'true') ? 'code' : 'symbol';
		}
		vm.allowmulti = (vm.allowmulti || 'false').toLowerCase();

		vm.default = { Value: null, CC: vm.defaultCc || (vm.config && vm.config.default) || '' };
		vm.model = $.isEmptyObject(vm.model) ? vm.default : vm.model;
		if (!vm.model.CC) {
			vm.model.CC = vm.default.CC;
		}
		vm.initializedCurrencyCode = vm.model.CC;

		vm.fieldWidth = vm.fieldWidth || 155;

		Object.defineProperty(vm, 'value', {
			get: function () {
				return vm.model ? getModel(vm.model).Value : null;
			},
			set: function (value = null) {
				const obj = vm.model ? getModel(vm.model) : { CC: vm.initializedCurrencyCode };
				if (obj.Value !== value) {
					obj.Value = value;
					vm.model = { Value: obj.Value, CC: obj.CC }; // important to change model
				}
			},
		});

		Object.defineProperty(vm, 'currencyCode', {
			get: function () {
				return vm.model ? getModel(vm.model).CC : vm.initializedCurrencyCode;
			},
			set: function (cc) {
				var obj = vm.model ? getModel(vm.model) : {};
				vm.model = { Value: obj.Value, CC: cc }; // important to change model
			},
		});

		Object.defineProperty(vm, 'currencySymbol', {
			get: function () {
				return getSymbolByCode(vm.currencyCode || vm.initializedCurrencyCode) || vm.currencyCode || vm.initializedCurrencyCode;
			},
		});

		getCurrencies().then((items) => (vm.currencies = items));

		setLabelOffset();
	};

	vm.$postLink = function () {
		vm.setHintHandlers($element.find('input'));
	};

	$scope.$watch('vm.externalCustomValidation.IsValid', () => checkValidation());
	$scope.$watch('vm.model', () => checkValidation(), true);

	vm.$onChanges = (changes) => {
		if (changes.required || changes.externalCustomValidation) {
			checkValidation();
		}
	};

	vm.onSelectBlur = onSelectBlur;
	vm.onSelectFocus = onSelectFocus;
	vm.onInputBlur = onInputBlur;

	function setLabelOffset() {
		setTimeout(function () {
			const labelEl = $element.find('.mx-currency--label');
			const offset = Math.round($element.find('.mx-currency--code-container').width());
			labelEl.css('left', -offset);
			$element.find('.mx-currency--field').css('max-width', `calc(100% - ${offset}px - 1px)`);
		});
	}

	function onInputBlur($event) {
		if ($event.relatedTarget === vm.codeSelect[0]) {
			$event.stopImmediatePropagation();
		}
		vm.onExternalBlur();
	}

	function onSelectBlur($event) {
		if ($event.relatedTarget !== vm.valueInput[0]) {
			vm.inputContainer.removeClass('md-input-focused');
			vm.onExternalBlur();
		}
	}

	function onSelectFocus() {
		vm.inputContainer.addClass('md-input-focused');
	}

	function getModel(model) {
		return typeof model === 'object' && model !== null ? model : { Value: model, CC: vm.initializedCurrencyCode };
	}

	function getSymbolByCode(code) {
		if (vm.config && vm.config.availableCurrencies) {
			var item = _.filter(vm.config.availableCurrencies, function (i) {
				return i.code === code;
			})[0];

			if (item) {
				return item.symbol;
			}
		}

		return null;
	}

	function getCurrencies() {
		var deferred = $q.defer();

		setTimeout(function () {
			if (vm.config && vm.config.availableCurrencies) {
				var result = vm.config.availableCurrencies.map(function (item) {
					return {
						DisplayString: vm.display === 'code' ? item.code : item.symbol,
						Value: item.code,
					};
				});

				deferred.resolve(result);
			} else {
				deferred.reject(null);
			}
		}, 5);

		return deferred.promise;
	}

	function hasValue() {
		return Boolean(vm.model && vm.model.Value);
	}

	function validate() {
		if (vm.required && !hasValue()) {
			return {
				IsValid: false,
				ErrorMessage: i18n.get('components.form-validation.required'),
			};
		}

		return vm.externalCustomValidation;
	}

	function checkValidation() {
		const validation = validate();

		if (!angular.equals(validation, vm.customValidation)) {
			vm.customValidation = { IsValid: true };
			$timeout(function () {
				vm.customValidation = validation;
			});
		}
	}

	return vm;
}

/**
 * @ngdoc directive
 * @name mx.components:mxCurrency
 * @module mx.components
 * @restrict 'E'
 * @description
 * The mx-currency control is used to display currency input field with currency code displayed.
 *
 * The control extends {@ref mx.components:FormControlBase FormControlBase} directive.
 *
 * @param {string} currencyCode@ - Currency code to be displayed.
 * @usage <mx-currency ng-model="vm.currencyValue" data-label="Currency editor" currency-code="{{vm.currencyCode}}"></mx-currency>
 */
angular.module('mx.components').directive('mxCurrency', function mxCurrencyDirective() {
	const directive = new mx.components.FormControlBase(MxCurrencyController, 'mx-currency/mx-currency.html');
	angular.extend(directive.bindToController, {
		allowmulti: '@',
		display: '@',
		config: '=?',
		defaultCc: '@',
		required: '<require',
		onExternalBlur: '&onBlur',
		externalCustomValidation: '<customValidation',
		focusOnInit: '<',
		fieldWidth: '@',
	});

	delete directive.bindToController.customValidation;

	return directive;
});
